const init = function () {
    document.addEventListener('input', (event) => {
        const input = event.target;

        if (!input.matches('[data-filter]')) {
            return;
        }

        const table = document.querySelector(input.dataset.filter);
        const value = input.value.toLowerCase();

        table?.querySelectorAll('tbody tr').forEach((row) => {
            row.style.display = row.textContent.toLowerCase().includes(value) ? '' : 'none';
        });
    });

}
export default {init};
